import React, {
  createContext,
  useReducer,
  useEffect,
  useState,
  useMemo,
  useCallback,
} from "react";
import { Router, Switch, Route } from "react-router-dom";
import { IntlProvider } from "react-intl";
import cls from "classnames";
import moment from "moment";
import vCon from "vconsole/dist/vconsole.min";
import "./App.scss";

// switch lang
import { langStringToCode } from "./Share/Tools/switchLang";
// api
import { getUiLangContent } from "./Api/GetUiLang";

// component
import TakeOrder from "./Pages/TakeOrder/TakeOrder";
import QrTakeOrder from "./Pages/QrTakeOrder/QrTakeOrder";
import ShowMenu from "./Pages/ShowMenu/ShowMenu";
import Error from "./Pages/Error/Error";
import QRCodeSuccessPage from "./Pages/QRCodeSuccessPage/QRCodeSuccessPage";
import OpenOrDownloadApp from "./Pages/OpenOrDownloadApp/OpenOrDownloadApp";
import IosDownloadPage from "./Pages/OpenOrDownloadApp/IosDownloadPage";
import TermsOfUse from "./Pages/TermsOfUse/TermsOfUse";
import PrivacyPolicy from "./Pages/PrivacyPolicy/PrivacyPolicy";
import ShowOrderDetail from "./Pages/ShowOrderDetail/ShowOrderDetail";
import StaffCheckOrder from "./Pages/StaffCheckOrder/StaffCheckOrder";
import StaffSearchOrder from "./Pages/StaffSearchOrder/StaffSearchOrder";
import StaffTakeOrder from "./Pages/StaffTakeOrder/StaffTakeOrder";
import StaffOrderDetail from "./Pages/StaffOrderDetail/StaffOrderDetail";
import StaffMenu from "./Pages/StaffMenu/StaffMenu";
import StaffMenuDetail from "./Pages/StaffMenu/StaffMenuDetail";
import StaffReminder from "./Pages/staffReminder/staffReminder";
import Loading from "./Components/Loading/Loading";

import NewHeader from "./Components/Header/NewHeader";

import _ from "lodash";
import { ErrorProvider } from "./Contexts/Error";

import { createBrowserHistory } from "history";
import {
  handlePromiseRejection,
  handleWindowError,
} from "./Components/Errors/errorReporter";

const history = createBrowserHistory({
  basename: window.env.BASENAME,
});

//let vc = new vCon();

const reducer = (state, { type, payload }) => {
  let newState = { ...state };
  console.log(type, payload);
  switch (type) {
    case "UPDATE":
      payload.forEach((i) => {
        newState = _.set(newState, i.key, i.val);
        // newState[i.key] = i.val;
      });
      // console.log(type, payload, newState)
      return newState;
    case "RESET":
      newState.langType = JSON.parse(localStorage.getItem("langType")) || "zh";
      newState.fontSize = JSON.parse(localStorage.getItem("fontSize")) || "sm";
      newState.device = (function () {
        switch (true) {
          case window.innerWidth > 576:
            return "pc";
          case window.innerWidth <= 576:
            return "mobile";
          default:
            throw Error("setInitGlobalState error");
        }
      })();
      newState.errMsg = null;
      // customer
      newState.customer = {
        currentStep: "1",
        currentQrStep: "0",
        QRCodeID: null,
        mealDetail: "",
        mealOrderDetail: [],
        emailAddress: newState.customer.emailAddress
          ? newState.customer.emailAddress
          : null,
        orderInfo: {
          queueNumber: "",
          queueCode: "",
          numberOfAdult: "",
          numberOfChild: "",
          country: "",
          orderTime: "",
          selectedBranch: null,
        },
        orderDetail: {
          totalMealQuantity: 0,
          dineInTotalPrice: 0,
          dineInSpecPrice: 0,
          takeoutInTotalPrice: 0,
          takeoutInSpecPrice: 0,
        },
      };
      // staff
      newState.staffInfo = {
        currentCheckOrderStep: "1",
        currentTakeOrderStep: "1",
        checkOrderBranch: null,
        checkOrderGroup: null,
        checkOrderStaff: null,
        checkOrderData: null,
        takeOrderData: null,
      };
      newState.selectedExtra = {
        selectedExtraQ: {},
        selectedExtraA: [],
      };
      newState.lastTimeUsed = moment().format("YYYY/MM/DD HH:mm:ss");
      return newState;
    case "LOGOUT":
      //舊的
      // newState.langType = JSON.parse(localStorage.getItem('langType')) || 'zh';
      //對單後語系切換繁中需求(測報154)
      newState.langType = "zh";
      newState.fontSize = JSON.parse(localStorage.getItem("fontSize")) || "sm";
      newState.device = (function () {
        switch (true) {
          case window.innerWidth > 576:
            return "pc";
          case window.innerWidth <= 576:
            return "mobile";
          default:
            throw Error("setInitGlobalState error");
        }
      })();
      newState.errMsg = null;
      // customer
      newState.customer = {
        currentStep: "1",
        currentQrStep: "0",
        QRCodeID: null,
        mealDetail: "",
        mealOrderDetail: [],
        emailAddress: newState.customer.emailAddress
          ? newState.customer.emailAddress
          : null,
        orderInfo: {
          queueNumber: "",
          queueCode: "",
          numberOfAdult: "",
          numberOfChild: "",
          country: "",
          orderTime: "",
          selectedBranch: null,
        },
        orderDetail: {
          totalMealQuantity: 0,
          dineInTotalPrice: 0,
          dineInSpecPrice: 0,
          takeoutInTotalPrice: 0,
          takeoutInSpecPrice: 0,
        },
      };
      newState.selectedExtra = {
        selectedExtraQ: {},
        selectedExtraA: [],
      };
      // staff
      newState.staffInfo = {
        currentCheckOrderStep: "1",
        currentTakeOrderStep: "1",
        checkOrderBranch: newState.staffInfo.checkOrderBranch,
        checkOrderGroup: "",
        checkOrderStaff: "",
        checkOrderData: null,
        takeOrderData: null,
      };
      return newState;
    default:
      return newState;
  }
};

// 初始化localStorage
function setInitGlobalState() {
  // langType
  const localLangType = localStorage.getItem("langType");
  if (!localLangType) localStorage.setItem("langType", JSON.stringify("zh"));
  // fontSize
  const fontSize = localStorage.getItem("fontSize");
  if (!fontSize) localStorage.setItem("fontSize", JSON.stringify("sm"));
  // device
  const device = localStorage.getItem("device");
  if (!device) {
    switch (true) {
      case window.innerWidth > 576:
        localStorage.setItem("device", JSON.stringify("pc"));
        break;
      case window.innerWidth <= 576:
        localStorage.setItem("device", JSON.stringify("mobile"));
        break;
      default:
        throw Error("setInitGlobalState error");
    }
  }
  // lastTimeUsed
  const lastTimeUsed = localStorage.getItem("lastTimeUsed");
  if (!lastTimeUsed)
    localStorage.setItem(
      "lastTimeUsed",
      JSON.stringify(moment().format("YYYY/MM/DD hh:mm:ss")),
    );
  // customer
  const customer = localStorage.getItem("customer");
  if (!customer)
    localStorage.setItem(
      "customer",
      JSON.stringify({
        currentStep: "1",
        currentQrStep: "0",
        QRCodeID: null,
        mealDetail: "",
        mealOrderDetail: [],
        orderInfo: {
          queueNumber: "",
          queueCode: "",
          numberOfAdult: "",
          numberOfChild: "",
          country: "",
          orderTime: "",
          selectedBranch: null,
        },
        orderDetail: {
          totalMealQuantity: 0,
          dineInTotalPrice: 0,
          dineInSpecPrice: 0,
          takeoutInTotalPrice: 0,
          takeoutInSpecPrice: 0,
        },
      }),
    );
  // staffInfo
  const staffInfo = localStorage.getItem("staffInfo");
  if (!staffInfo)
    localStorage.setItem(
      "staffInfo",
      JSON.stringify({
        currentCheckOrderStep: "1",
        checkOrderBranch: null,
        checkOrderGroup: null,
        checkOrderStaff: null,
        checkOrderData: null,
        takeOrderData: null,
      }),
    );

  const selectedExtra = localStorage.getItem("selectedExtra");
  if (!selectedExtra)
    localStorage.setItem(
      "selectedExtra",
      JSON.stringify({
        selectedExtraA: null,
        selectedExtraQ: null,
      }),
    );
}
setInitGlobalState();

const userType = () => {
  let pathname = window.location.pathname.replace(/<[^>]*>|/g, "");
  if (pathname.toLowerCase().indexOf("staff") > -1) {
    return 2;
  } else {
    return 1;
  }
};

// css class
function handleFontSize(device, fontSize) {
  if (device === "pc") return "pcModeFont";
  if (device === "mobile") {
    // 門市人員固定用大字
    // if (fontSize === 'xl' || userType() === 'staff') return 'biggerFont';
    if (fontSize === "xl") return "biggerFont";
    if (fontSize === "sm") return "regularFont";
  } else {
    throw Error("handleFontSize error");
  }
}

function App() {
  const [state, setState] = useState({
    isReady: false,
  });

  const [globalState, dispatchGlobal] = useReducer(reducer, {
    ordermode: JSON.parse(localStorage.getItem("ordermode")),
    langType: JSON.parse(localStorage.getItem("langType")),
    langFile: null,
    fontSize: JSON.parse(localStorage.getItem("fontSize")),
    device: JSON.parse(localStorage.getItem("device")),
    errMsg: JSON.parse(localStorage.getItem("errMsg")),
    // customer
    customer: JSON.parse(localStorage.getItem("customer")),
    // staff
    staffInfo: JSON.parse(localStorage.getItem("staffInfo")),
    lastTimeUsed: JSON.parse(localStorage.getItem("lastTimeUsed")),
  });
  // 檢查上次使用系統的時間

  const overTimeReset = useCallback(() => {
    const lastTimeUsed = globalState.lastTimeUsed;
    // lastUseTime
    let lastUseTime = moment(lastTimeUsed).format("YYYY/MM/D");
    // now
    let now = moment().format("YYYY/MM/D");
    // 如果當前日期 與 上次點餐時的日期不同時直接重置localStorage
    if (lastUseTime !== now) {
      console.log("overTimeReset");
      dispatchGlobal({ type: "RESET" });
    }
  }, [globalState.lastTimeUsed]);
  // function overTimeReset() {

  // }
  // 偵測螢幕尺寸
  function checkWindow() {
    let width = window.innerWidth;
    let localFontSize = JSON.parse(localStorage.getItem("fontSize"));
    if (width > 576) {
      dispatchGlobal({
        type: "UPDATE",
        payload: [
          { key: "fontSize", val: "pc" },
          { key: "device", val: "pc" },
        ],
      });
    } else {
      if (!localFontSize) {
        dispatchGlobal({
          type: "UPDATE",
          payload: [
            { key: "fontSize", val: "sm" },
            { key: "device", val: "mobile" },
          ],
        });
      }
      if (localFontSize && localFontSize !== "pc") {
        dispatchGlobal({
          type: "UPDATE",
          payload: [
            { key: "fontSize", val: localFontSize },
            { key: "device", val: "mobile" },
          ],
        });
      }
      if (localFontSize && localFontSize === "pc") {
        dispatchGlobal({
          type: "UPDATE",
          payload: [
            { key: "fontSize", val: "sm" },
            { key: "device", val: "mobile" },
          ],
        });
      }
    }
  }

  // ui語系內文
  async function apiUiLangContent(langId) {
    try {
      let res = await getUiLangContent(langId, userType());
      const { jsonString } = res.data.result;
      let uiLangContent = JSON.parse(jsonString);
      return uiLangContent;
    } catch (err) {
      console.error("UiLangContent error.");
      dispatchGlobal({
        type: "UPDATE",
        payload: [{ key: "errMsg", val: null }],
      });
    }
  }

  // 更新localStorage
  useEffect(() => {
    for (let i in globalState) {
      let local = JSON.parse(localStorage.getItem(i));
      let global = globalState[i];
      // 資料一樣不更新
      if (JSON.stringify(local) !== JSON.stringify(global)) {
        if (i === "langFile") {
          // 防止寫入langFile
        } else if (i === "customer" || i === "staffInfo") {
          let parser = {
            ...globalState[i],
            isReady: null,
          };
          localStorage.setItem(i, JSON.stringify(parser));
        } else {
          localStorage.setItem(i, JSON.stringify(globalState[i]));
        }
      }
    }
  }, [globalState]);

  // 更新語系
  useEffect(() => {
    dispatchGlobal({
      type: "UPDATE",
      payload: [{ key: "changingLangType", val: true }],
    });
    async function handleChangeLang() {
      let uiContent = await apiUiLangContent(
        langStringToCode(globalState.langType),
      );
      console.log({ uiContent });
      dispatchGlobal({
        type: "UPDATE",
        payload: [
          { key: "langFile", val: uiContent },
          { key: "changingLangType", val: false },
        ],
      });
    }
    handleChangeLang();
  }, [globalState.langType]);

  const $checkReset = useCallback(() => {
    if (
      window.location.search !== undefined &&
      window.location.search !== null &&
      window.location.search.includes("isClear")
    ) {
      dispatchGlobal({ type: "RESET" });
      history.push("/");
    } else {
      const lastTimeUsed = globalState.lastTimeUsed;
      // lastUseTime
      let lastUseTime = moment(lastTimeUsed).format("YYYY/MM/D");
      // now
      let now = moment().format("YYYY/MM/D");
      // 如果當前日期 與 上次點餐時的日期不同時直接重置localStorage
      if (lastUseTime !== now) {
        dispatchGlobal({ type: "RESET" });
      }
    }

    setState({ isReady: true });
  }, [globalState.lastTimeUsed]);

  useEffect(() => {
    $checkReset();
  }, [$checkReset]);
  // 沒有Ui語系不渲染畫面
  // if (!globalState.langFile) return null;

  if (!state.isReady || !globalState.langFile) {
    return null;
  }

  return (
    <IntlProvider locale={globalState.langType} messages={globalState.langFile}>
      <Global.Provider
        value={{
          globalState: globalState,
          dispatchGlobal: dispatchGlobal,
        }}
      >
        <Router history={history}>
          <>
            <NewHeader
              fontSize={handleFontSize(
                globalState.device,
                globalState.fontSize,
              )}
            />
            <div
              className={cls(
                "container pl-4 pr-4 p-sm-0",
                handleFontSize(globalState.device, globalState.fontSize),
                // 針對門市訂單查詢頁特製高度
                window.location.pathname.toLowerCase() === "/staffsearchorder"
                  ? "staffSearchOrderContainer"
                  : "",
              )}
            >
              <div className="content">
                <ErrorProvider>
                  <Switch>
                    {/* customer */}
                    <Route exact path="/" component={TakeOrder} />
                    <Route path="/showMenu" component={ShowMenu} />
                    <Route path="/error" component={Error} />
                    <Route path="/staff/error" component={Error} />
                    <Route
                      path="/QRCodeSuccess"
                      component={QRCodeSuccessPage}
                    />
                    <Route
                      path="/OpenOrDownloadApp"
                      component={OpenOrDownloadApp}
                    />
                    <Route path="/download_app" component={IosDownloadPage} />
                    <Route path="/termsOfUse" component={TermsOfUse} />
                    <Route path="/privacyPolicy" component={PrivacyPolicy} />
                    <Route
                      path="/showOrderDetail"
                      component={ShowOrderDetail}
                    />
                    <Route path="/TakeOrderOnline" component={QrTakeOrder} />
                    {/* staff */}
                    <Route
                      path="/staffCheckOrder"
                      component={StaffCheckOrder}
                    />
                    <Route
                      path="/staffSearchOrder"
                      component={StaffSearchOrder}
                    />
                    <Route path="/staffTakeOrder" component={StaffTakeOrder} />
                    <Route
                      path="/staffOrderDetail"
                      component={StaffOrderDetail}
                    />
                    <Route path="/staffMenu" component={StaffMenu} />
                    <Route
                      path="/staffMenuDetail"
                      component={StaffMenuDetail}
                    />
                    <Route path="/staffReminder" component={StaffReminder} />
                  </Switch>
                </ErrorProvider>

                {/* 切換語系開啟loading */}
                <Loading show={globalState.changingLangType}></Loading>
              </div>
            </div>
          </>
        </Router>
      </Global.Provider>
    </IntlProvider>
  );
}

export const Global = createContext({});
export default App;
